import React from 'react';

interface ThumbnailPreviewProps {
    previewMedia: string[];
    onThumbnailClick: (imageUrl: string) => void;
}

const ProductPageHeaderPreviewThumbnail: React.FC<ThumbnailPreviewProps> = ({ previewMedia, onThumbnailClick }) => {
    const isVideo = (file: string) => /\.(mp4|webm|avi|mov)$/i.test(file);

    return (
        <div className="thumbnail-preview d-flex overflow-auto my-2">
            {previewMedia.map((fileUrl, index) => (
                <div
                    key={index}
                    className={`thumbnail-container ${isVideo(fileUrl) ? 'video-thumbnail' : ''}`}
                    onClick={() => onThumbnailClick(fileUrl)}
                    style={{ cursor: 'pointer' }}
                >
                    {isVideo(fileUrl) ? (
                        <>
                            <video
                                src={fileUrl}
                                className="img-thumbnail gallery-thumbnail"
                                muted
                            />
                            <span className="play-icon">▶</span>
                        </>
                    ) : (
                        <img
                            src={fileUrl}
                            className="img-thumbnail gallery-thumbnail"
                            alt={`Thumbnail ${index + 1}`}
                        />
                    )}
                </div>
            ))}
        </div>
    );
};

export default ProductPageHeaderPreviewThumbnail;

